module.exports = __webpack_public_path__ + "static/media/intro-img-sep.cb0a72e6.png";